// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]7.2-rc-12369(c96d78ae9a)-C23/04/2026-07:52:26-B23/04/2026-07:54:30' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]7.2-rc-12369(c96d78ae9a)-C23/04/2026-07:52:26-B23/04/2026-07:54:30",
  branch: "test",
  latestTag: "7.2-rc",
  revCount: "12369",
  shortHash: "c96d78ae9a",
  longHash: "c96d78ae9a678752c8ae1e961e35520bd4ef0734",
  dateCommit: "23/04/2026-07:52:26",
  dateBuild: "23/04/2026-07:54:30",
  buildType: "Ansible",
  } ;
